// extracted by mini-css-extract-plugin
export var emailBlockLink = "_nm-0";